import * as React from 'react';
import { IconProps } from '../../dto/Interfaces/IIconProps';

export const FacebookIcon: React.FC<IconProps> = ({ color, size, style }) => {
  return (
    <svg
      style={style}
      xmlns="http://www.w3.org/2000/svg"
      width={size ?? '20'}
      height={size ?? '20'}
      viewBox="0 0 20 20"
      fill="none"
      data-testid="facebook-icon"
    >
      <path
        fill={color ?? '#fff'}
        d="M11.164 17.898v-6.83h2.304l.342-2.674h-2.646V6.69c0-.771.215-1.3 1.322-1.3h1.403V3.006a18.614 18.614 0 00-2.055-.106c-2.037 0-3.435 1.244-3.435 3.526V8.39h-2.29v2.674h2.295v6.835h2.76z"
      />
    </svg>
  );
};

export default FacebookIcon;
